import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const WEditor = ({ value, onChange }) => {

  const modules = {
    toolbar: [
      ["bold", "italic", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]
  };

  const formats = [
    "bold",
    "italic",
    "strike",
    "list",
    "bullet"
  ];

  return (
    <div className="weditor-wrapper">
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default WEditor;
